import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';

import '../styles/Servicehero.css';

import img1 from '../assets/electricaldesign.jpg';
import img6 from '../assets/maintananceservice.jpg';
import img7 from '../assets/testing.jpg';

const slides = [
  {
    img: img1,
    heading: "Engineering Design",
    description: "We deliver innovative engineering solutions.",
    route: "service1",
  },
  {
    img: img7,
    heading: "Testing & Commissioning",
    description: "Thorough testing before going live.",
    route: "service2",
  },
  {
    img: img6,
    heading: "Maintenance Services",
    description: "Reliable servicing for uninterrupted operations.",
    route: "service6",
  },
];

const Servicehero = () => {
  return (
    <div className="servicehero-container">
      <Swiper
        grabCursor={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        modules={[Pagination, Autoplay]}
        className="servicehero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className="normal-slide">
            <Link to={`/services/${slide.route}`} className="slide-link">
              <img src={slide.img} alt={`Slide ${index + 1}`} className="hero-image" />
              <div className="slide-overlay">
                <h1>{slide.heading}</h1>
                <p>{slide.description}</p>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Servicehero;
